import api from "../../utils/axiosInstance";

export const fetchBrowsStudentRequestedListDataRequest = () => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_REQUEST",
});

export const fetchBrowsStudentRequestedListDataSuccess = (data) => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchBrowsStudentRequestedListDataFailure = (error) => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_FAILURE",
    payload: error,
});

export const getBrowsStudentRequestedListData = () => async (dispatch) => {
    dispatch(fetchBrowsStudentRequestedListDataRequest());
    try {
        const authToken = localStorage.getItem('tutor-token')
        let response = await api.get(`/api/tutor/requested-tutor`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;
        dispatch(fetchBrowsStudentRequestedListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchBrowsStudentRequestedListDataFailure(error.message));
    }
};

export const fetchBrowsStudentRequestedDetailDataRequest = () => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_REQUEST",
});

export const fetchBrowsStudentRequestedDetailDataSuccess = (data) => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchBrowsStudentRequestedDetailDataFailure = (error) => ({
    type: "FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getBrowsStudentRequestedDetailData = (id) => async (dispatch) => {
    dispatch(fetchBrowsStudentRequestedDetailDataRequest());
    try {
        const authToken = localStorage.getItem('tutor-token')
        let response = await api.get(`/api/web/requested-tutor-details?request_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;
        dispatch(fetchBrowsStudentRequestedDetailDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchBrowsStudentRequestedDetailDataFailure(error.message));
    }
};

export const fetchBrowseStudentApprovedListDataRequest = () => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_REQUEST",
});

export const fetchBrowseStudentApprovedListDataSuccess = (data) => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchBrowseStudentApprovedListDataFailure = (error) => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_FAILURE",
    payload: error,
});

export const getBrowseStudentApprovedListData = () => async (dispatch) => {
    dispatch(fetchBrowseStudentApprovedListDataRequest());
    try {
        const authToken = localStorage.getItem('tutor-token')
        let response = await api.get(`/api/tutor/requested-tutor/approvedList`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;
        dispatch(fetchBrowseStudentApprovedListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchBrowseStudentApprovedListDataFailure(error.message));
    }
};

export const fetchBrowseStudentApprovedDetailDataRequest = () => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_REQUEST",
});

export const fetchBrowseStudentApprovedDetailDataSuccess = (data) => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchBrowseStudentApprovedDetailDataFailure = (error) => ({
    type: "FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getBrowseStudentApprovedDetailData = (id) => async (dispatch) => {
    dispatch(fetchBrowseStudentApprovedDetailDataRequest());
    try {
        const authToken = localStorage.getItem('tutor-token')
        let response = await api.get(`/api/web/requested-tutor/approvedListDetails?request_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;
        dispatch(fetchBrowseStudentApprovedDetailDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchBrowseStudentApprovedDetailDataFailure(error.message));
    }
};

// TUTOR category data
export const fetchTutorCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_CATEGORY_DATA_REQUEST",
});

export const fetchTutorCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorCategoryData = () =>

    async (dispatch) => {

        dispatch(fetchTutorCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/tutor-master/category`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorCategoryDataFailure(error.message));
        }
    }

// TUTOR category data
export const fetchTutorStudyMaterialVideoListDataRequest = () => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_REQUEST",
});

export const fetchTutorStudyMaterialVideoListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialVideoListDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialVideoListData = (query) =>

    async (dispatch) => {

        dispatch(fetchTutorStudyMaterialVideoListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?material_type=video&${query}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorStudyMaterialVideoListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorStudyMaterialVideoListDataFailure(error.message));
        }
    }

// TUTOR category data
export const fetchTutorStudyMaterialImageListDataRequest = (query) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_REQUEST",
});

export const fetchTutorStudyMaterialImageListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialImageListDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialImageListData = (query) =>

    async (dispatch) => {

        dispatch(fetchTutorStudyMaterialImageListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?material_type=image&${query}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorStudyMaterialImageListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorStudyMaterialImageListDataFailure(error.message));
        }
    }

// TUTOR category data
export const fetchTutorStudyMaterialPdfListDataRequest = () => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_REQUEST",
});

export const fetchTutorStudyMaterialPdfListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialPdfListDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialPdfListData = (query) =>

    async (dispatch) => {

        dispatch(fetchTutorStudyMaterialPdfListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?material_type=pdf&${query}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorStudyMaterialPdfListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorStudyMaterialPdfListDataFailure(error.message));
        }
    }

// TUTOR category data
export const fetchTutorStudyMaterialListGroupDataRequest = () => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_REQUEST",
});

export const fetchTutorStudyMaterialListGroupDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialListGroupDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialListGroupData = () =>

    async (dispatch) => {

        dispatch(fetchTutorStudyMaterialListGroupDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?teaching_type_id=1`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorStudyMaterialListGroupDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorStudyMaterialListGroupDataFailure(error.message));
        }
    }

// TUTOR group category data
export const fetchTutorGroupCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_GROUP_CATEGORY_DATA_REQUEST",
});

// new code add for studey material

// TUTOR study material PPT list data
export const fetchTutorStudyMaterialPptListDataRequest = () => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_REQUEST",
});

export const fetchTutorStudyMaterialPptListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialPptListDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialPptListData = (query) =>
    async (dispatch) => {
        dispatch(fetchTutorStudyMaterialPptListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?material_type=ppt&${query}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });
            const data = response.data;
            let desired_data = data?.data;
            dispatch(fetchTutorStudyMaterialPptListDataSuccess(desired_data));
        } catch (error) {
            dispatch(fetchTutorStudyMaterialPptListDataFailure(error.message));
        }
    }

// TUTOR study material DOC list data
export const fetchTutorStudyMaterialDocListDataRequest = () => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_REQUEST",
});

export const fetchTutorStudyMaterialDocListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorStudyMaterialDocListDataFailure = (error) => ({
    type: "FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorStudyMaterialDocListData = (query) =>
    async (dispatch) => {
        dispatch(fetchTutorStudyMaterialDocListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/study-material?material_type=doc&${query}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });
            const data = response.data;
            let desired_data = data?.data;
            dispatch(fetchTutorStudyMaterialDocListDataSuccess(desired_data));
        } catch (error) {
            dispatch(fetchTutorStudyMaterialDocListDataFailure(error.message));
        }
    }




export const fetchTutorGroupCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_GROUP_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorGroupCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_GROUP_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorGroupCategoryData = () =>

    async (dispatch) => {

        dispatch(fetchTutorGroupCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-category?teaching_type=1`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorGroupCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorGroupCategoryDataFailure(error.message));
        }
    }

// TUTOR one to one category data
export const fetchTutorOneCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_ONE_CATEGORY_DATA_REQUEST",
});

export const fetchTutorOneCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_ONE_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorOneCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_ONE_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorOneCategoryData = () =>

    async (dispatch) => {

        dispatch(fetchTutorOneCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-category?teaching_type=0`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorOneCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorOneCategoryDataFailure(error.message));
        }
    }

// TUTOR group category data
export const fetchTutorGroupSubCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_REQUEST",
});

export const fetchTutorGroupSubCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorGroupSubCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorGroupSubCategoryData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorGroupSubCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-sub-category?teaching_type=1&category_id=${id}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorGroupSubCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorGroupSubCategoryDataFailure(error.message));
        }
    }

// TUTOR one to one category data
export const fetchTutorOneSubCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_REQUEST",
});

export const fetchTutorOneSubCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorOneSubCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorOneSubCategoryData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorOneSubCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-sub-category?teaching_type=0&category_id=${id}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorOneSubCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorOneSubCategoryDataFailure(error.message));
        }
    }

// TUTOR group category data
export const fetchTutorGroupChildCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_REQUEST",
});

export const fetchTutorGroupChildCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorGroupChildCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorGroupChildCategoryData = (catId, subcatId) =>

    async (dispatch) => {

        dispatch(fetchTutorGroupChildCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-child-sub-category?teaching_type=1&category_id=${catId}&sub_category_id=${subcatId}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorGroupChildCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorGroupChildCategoryDataFailure(error.message));
        }
    }

// TUTOR one to one category data
export const fetchTutorOneChildCategoryDataRequest = () => ({
    type: "FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_REQUEST",
});

export const fetchTutorOneChildCategoryDataSuccess = (data) => ({
    type: "FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorOneChildCategoryDataFailure = (error) => ({
    type: "FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getTutorOneChildCategoryData = (catId, subcatId) =>

    async (dispatch) => {

        dispatch(fetchTutorOneChildCategoryDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/assessment/add-assess-child-sub-category?teaching_type=1&category_id=${catId}&sub_category_id=${subcatId}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorOneChildCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorOneChildCategoryDataFailure(error.message));
        }
    }

// tutor course group list
export const fetchTutorMyCourseGroupListDataRequest = () => ({
    type: "FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_REQUEST",
});

export const fetchTutorMyCourseGroupListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyCourseGroupListDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorMyCourseGroupListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorMyCourseGroupListDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')

            const response = await api.get(`/api/tutor/get-group-course-list`, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyCourseGroupListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyCourseGroupListDataFailure(error.message));
        }
    }

// tutor course one to one list
export const fetchTutorMyCourseOneToOneListDataRequest = () => ({
    type: "FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_REQUEST",
});

export const fetchTutorMyCourseOneToOneListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyCourseOneToOneListDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorMyCourseOneToOneListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorMyCourseOneToOneListDataRequest());
        try {
            const values = { "teaching_type": "0" }
            const authToken = localStorage.getItem('tutor-token')

            const response = await api.post(`/api/tutor/get-course-list`, values, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyCourseOneToOneListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyCourseOneToOneListDataFailure(error.message));
        }
    }

// tutor course group BATCH list
export const fetchTutorMyCourseBatchListDataRequest = () => ({
    type: "FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_REQUEST",
});

export const fetchTutorMyCourseBatchListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyCourseBatchListDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorMyCourseBatchListData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorMyCourseBatchListDataRequest());
        try {
            const values = { "course_id": id }
            const authToken = localStorage.getItem('tutor-token')
            const response = await api.post(`/api/tutor/get-batch-by-course`, values, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyCourseBatchListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyCourseBatchListDataFailure(error.message));
        }
    }

// tutor my booked schedule one to one list
export const fetchTutorMyBookedScheduleOneListDataRequest = () => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_REQUEST",
});

export const fetchTutorMyBookedScheduleOneListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyBookedScheduleOneListDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorMyBookedScheduleOneListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorMyBookedScheduleOneListDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/tutor/get-booked-course-list?teaching_type=0`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyBookedScheduleOneListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyBookedScheduleOneListDataFailure(error.message));
        }
    }

// tutor my booked schedule one to one list
export const fetchTutorMyBookedScheduleGroupListDataRequest = () => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_REQUEST",
});

export const fetchTutorMyBookedScheduleGroupListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyBookedScheduleGroupListDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorMyBookedScheduleGroupListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorMyBookedScheduleGroupListDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/tutor/get-booked-course-list?teaching_type=1`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyBookedScheduleGroupListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyBookedScheduleGroupListDataFailure(error.message));
        }
    }

// tutor my booked schedule one to one list
export const fetchTutorMyBookedScheduleDetailDataRequest = () => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_REQUEST",
});

export const fetchTutorMyBookedScheduleDetailDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyBookedScheduleDetailDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getTutorMyBookedScheduleDetailData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorMyBookedScheduleDetailDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/tutor/get-booking-summery-details?booking_id=${id}`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyBookedScheduleDetailDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyBookedScheduleDetailDataFailure(error.message));
        }
    }

export const fetchTutorViewAssListDataRequest = () => ({
    type: "FETCH_TUTOR_VIEW_ASS_LIST_DATA_REQUEST",
});

export const fetchTutorViewAssListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_VIEW_ASS_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorViewAssListDataFailure = (error) => ({
    type: "FETCH_TUTOR_VIEW_ASS_LIST_DATA_FAILURE",
    payload: error,
});

export const fetchTutorViewAssDetailRequest = () => ({
    type: "FETCH_TUTOR_VIEW_ASS_DETAIL_REQUEST",
});

export const fetchTutorViewAssDetailSuccess = (data) => ({
    type: "FETCH_TUTOR_VIEW_ASS_DETAIL_SUCCESS",
    payload: data,
});

export const fetchTutorViewAssDetailFailure = (error) => ({
    type: "FETCH_TUTOR_VIEW_ASS_DETAIL_FAILURE",
    payload: error,
});

export const getTutorViewAssDetail = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorViewAssDetailRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/web/my-assessment-details?assessment_id=${id}`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorViewAssDetailSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorViewAssDetailFailure(error.message));
        }
    }

export const getTutorViewAssListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorViewAssListDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/tutor/my-assessment`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorViewAssListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorViewAssListDataFailure(error.message));
        }
    }

export const fetchTutorCompletedAssListDataRequest = () => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_REQUEST",
});

export const fetchTutorCompletedAssListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorCompletedAssListDataFailure = (error) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorCompletedAssListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorCompletedAssListDataRequest());
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.get(`/api/tutor/view-accomplished-assesment`, {
                headers: {
                    "x-auth-token": authToken,
                },

            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorCompletedAssListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorCompletedAssListDataFailure(error.message));
        }
    }

// tutor course group BATCH list
export const fetchTutorCompletedAssStudentListDataRequest = () => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_REQUEST",
});

export const fetchTutorCompletedAssStudentListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorCompletedAssStudentListDataFailure = (error) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorCompletedAssStudentListData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorCompletedAssStudentListDataRequest());
        try {
            const values = { "assesment_id": id }
            const authToken = localStorage.getItem('tutor-token')
            const response = await api.post(`/api/tutor/view-accomplished-assesment-students-new`, values, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorCompletedAssStudentListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorCompletedAssStudentListDataFailure(error.message));
        }
    }

// tutor course group BATCH list
export const fetchTutorCompletedAssStudentDetailRequest = () => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_REQUEST",
});

export const fetchTutorCompletedAssStudentDetailSuccess = (data) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_SUCCESS",
    payload: data,
});

export const fetchTutorCompletedAssStudentDetailFailure = (error) => ({
    type: "FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_FAILURE",
    payload: error,
});

export const getTutorCompletedAssStudentDetail = (assessment_id, student_id) =>

    async (dispatch) => {

        dispatch(fetchTutorCompletedAssStudentDetailRequest());
        try {

            const values = { 'assessment_id': assessment_id, 'student_id': student_id }
            const authToken = localStorage.getItem('tutor-token')
            const response = await api.post(`/api/web/completed-ass-student-details`, values, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorCompletedAssStudentDetailSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorCompletedAssStudentDetailFailure(error.message));
        }
    }

// tutor booked student list
export const fetchTutorBookedStudentListRequest = () => ({
    type: "FETCH_TUTOR_BOOKED_STUDENT_LIST_REQUEST",
});

export const fetchTutorBookedStudentListSuccess = (data) => ({
    type: "FETCH_TUTOR_BOOKED_STUDENT_LIST_SUCCESS",
    payload: data,
});

export const fetchTutorBookedStudentListFailure = (error) => ({
    type: "FETCH_TUTOR_BOOKED_STUDENT_LIST_FAILURE",
    payload: error,
});

export const getTutorBookedStudentList = (values) =>

    async (dispatch) => {

        dispatch(fetchTutorBookedStudentListRequest(values));
        try {

            const authToken = localStorage.getItem('tutor-token')
            const response = await api.post(`/api/tutor/get-booked-student-list`, values, {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorBookedStudentListSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorBookedStudentListFailure(error.message));
        }
    }

export const fetchTutorMyBookingsListRequest = () => ({
    type: "FETCH_MY_BOOKINGS_LIST_REQUEST",
});

export const fetchTutorMyBookingsListSuccess = (data) => ({
    type: "FETCH_MY_BOOKINGS_LIST_SUCCESS",
    payload: data,
});

export const fetchTutorMyBookingsListFailure = (error) => ({
    type: "FETCH_MY_BOOKINGS_LIST_FAILURE",
    payload: error,
});

export const getTutorMyBookingsList = () =>

    async (dispatch) => {

        dispatch(fetchTutorMyBookingsListRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/get-booking-summery`, {
                headers: {
                    "x-auth-token": authToken,
                },
            });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyBookingsListSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorMyBookingsListFailure(error.message));
        }
    }

export const fetchTutorNotificationListDataRequest = () => ({
    type: "FETCH_TUTOR_NOTIFICATION_LIST_DATA_REQUEST",
});

export const fetchTutorNotificationListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_NOTIFICATION_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorNotificationListDataFailure = (error) => ({
    type: "FETCH_TUTOR_NOTIFICATION_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorNotificationListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorNotificationListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/student/notification`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorNotificationListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorNotificationListDataFailure(error.message));
        }
    }

export const fetchTutorSmallNotificationListDataRequest = () => ({
    type: "FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_REQUEST",
});

export const fetchTutorSmallNotificationListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorSmallNotificationListDataFailure = (error) => ({
    type: "FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorSmallNotificationListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorSmallNotificationListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/web/notification-list`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorSmallNotificationListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorSmallNotificationListDataFailure(error.message));
        }
    }

export const fetchTutorQueryListDataRequest = () => ({
    type: "FETCH_TUTOR_QUERY_LIST_DATA_REQUEST",
});

export const fetchTutorQueryListDataSuccess = (data) => ({
    type: "FETCH_TUTOR_QUERY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorQueryListDataFailure = (error) => ({
    type: "FETCH_TUTOR_QUERY_LIST_DATA_FAILURE",
    payload: error,
});

export const getTutorQueryListData = () =>

    async (dispatch) => {

        dispatch(fetchTutorQueryListDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/student-query`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorQueryListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorQueryListDataFailure(error.message));
        }
    }

// student category data
export const fetchTutorQueriesDetailDataRequest = () => ({
    type: "FETCH_TUTOR_QUERIES_DETAIL_DATA_REQUEST",
});

export const fetchTutorQueriesDetailDataSuccess = (data) => ({
    type: "FETCH_TUTOR_QUERIES_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorQueriesDetailDataFailure = (error) => ({
    type: "FETCH_TUTOR_QUERIES_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getTutorQueriesDetailData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorQueriesDetailDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/web/student-query-details?query_id=${id}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorQueriesDetailDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTutorQueriesDetailDataFailure(error.message));
        }
    }

// student category data
export const fetchTutorReviewDataRequest = () => ({
    type: "FETCH_TUTOR_REVIEW_DATA_REQUEST",
});

export const fetchTutorReviewDataSuccess = (data) => ({
    type: "FETCH_TUTOR_REVIEW_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorReviewDataFailure = (error) => ({
    type: "FETCH_TUTOR_REVIEW_DATA_FAILURE",
    payload: error,
});

export const getTutorReviewData = (id) =>

    async (dispatch) => {

        dispatch(fetchTutorReviewDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response = await api.get(`/api/tutor/get-rate-and-review?id=${id}`,
                {
                    headers: {
                        "x-auth-token": authToken,
                    }
                });

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorReviewDataSuccess(data));

        } catch (error) {
            dispatch(fetchTutorReviewDataFailure(error.message));
        }
    }

// student category data
export const fetchTutorMyEarningsDataRequest = () => ({
    type: "FETCH_TUTOR_MY_EARNINGS_DATA_REQUEST",
});

export const fetchTutorMyEarningsDataSuccess = (data) => ({
    type: "FETCH_TUTOR_MY_EARNINGS_DATA_SUCCESS",
    payload: data,
});

export const fetchTutorMyEarningsDataFailure = (error) => ({
    type: "FETCH_TUTOR_MY_EARNINGS_DATA_FAILURE",
    payload: error,
});

export const getTutorMyEarningsData = (start_date, end_date) =>

    async (dispatch) => {

        dispatch(fetchTutorMyEarningsDataRequest());
        try {
            const authToken = localStorage.getItem('tutor-token')
            let response
            if (start_date != '' && end_date != '') {
                response = await api.get(`/api/tutor/earning?start_date=${start_date}&end_date=${end_date}`,
                    {
                        headers: {
                            "x-auth-token": authToken,
                        }
                    });
            }
            if (end_date == '' && start_date == '') {
                response = await api.get(`/api/tutor/earning`,
                    {
                        headers: {
                            "x-auth-token": authToken,
                        }
                    });
            }
            if (start_date != '' && end_date == '') {
                response = await api.get(`/api/tutor/earning?start_date=${start_date}`,
                    {
                        headers: {
                            "x-auth-token": authToken,
                        }
                    });
            }

            if (start_date == '' && end_date != '') {
                response = await api.get(`/api/tutor/earning?end_date=${end_date}`,
                    {
                        headers: {
                            "x-auth-token": authToken,
                        }
                    });
            }

            const data = response.data;
            let desired_data = data?.data;

            dispatch(fetchTutorMyEarningsDataSuccess(data));

        } catch (error) {
            dispatch(fetchTutorMyEarningsDataFailure(error.message));
        }
    }